import React from 'react';
import { Scale } from 'lucide-react';
import { RecordCard, EmptyState, UploadButton } from './RecordHelpers';

export const RegulatoryDocsTab = ({ reportorial, term, onArchive, onUploadOpen }) => (
  <div className="space-y-4">
    <div className="flex justify-end"><UploadButton tab="regulatory" defaultType="filing" onOpen={onUploadOpen} /></div>
    {reportorial.filter(r => (r.title || '').toLowerCase().includes(term)).length === 0 ? (
      <EmptyState icon={Scale} message={term ? 'No matches' : 'No regulatory documents yet'} sub="Reportorial requirements and filings will appear here" />
    ) : (
      <div className="grid md:grid-cols-2 gap-3">
        {reportorial.filter(r => (r.title || '').toLowerCase().includes(term)).map(r => (
          <RecordCard key={r.id} record={r} icon={<Scale className="h-5 w-5 text-[#F58A26]" />} color="#F58A26" onArchive={onArchive} />
        ))}
      </div>
    )}
  </div>
);
